var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIdialogueIconBlank = function SvgIdialogueIconBlank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34.798mm",
    height: "28.915mm",
    viewBox: "0 0 34.798 28.915",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expanded",
    fill: "#f60",
    style: {
      mixBlendMode: "normal"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0031204,
    width: 30.148,
    height: 25.94,
    strokeWidth: 0.26482
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.619 25.869 12.179 3.0448-4.6541-5.9591z",
    strokeWidth: 0
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdialogueIconBlank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/idialogue-icon-blank.0ed9f002.svg";
export { ForwardRef as ReactComponent };